module.exports = __webpack_public_path__ + "static/media/snapshot4a.8f67d860.png";